import { ComponentType } from '@angular/cdk/overlay';
import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  private readonly DEFAULT_ACTION = 'Close';
  private readonly _matSnackBar = inject(MatSnackBar);

  showError(errorMessage: string, action: string = this.DEFAULT_ACTION) {
    this._matSnackBar.open(errorMessage, action, {
      duration: 6000,
      panelClass: 'error-snackbar',
    });
  }

  showInfo(message: string, action: string = this.DEFAULT_ACTION) {
    this._matSnackBar.open(message, action, { duration: 3000, panelClass: 'success-snackbar' });
  }

  showPermanentInfo(message: string, action: string = this.DEFAULT_ACTION) {
    this._matSnackBar.open(message, action, { panelClass: 'success-snackbar' });
  }

  showPermanentError(errorMessage: string, action: string = this.DEFAULT_ACTION) {
    this._matSnackBar.open(errorMessage, action, { panelClass: 'error-snackbar' });
  }

  showWithComponent<T>(component: ComponentType<unknown>, data: T, duration?: number) {
    this._matSnackBar.openFromComponent(component, { data: data, duration: duration });
  }

  dismiss() {
    this._matSnackBar.dismiss();
  }
}
